export default function genererPositionnementCheque() {
  return {
    montantEnLettreY2: null,
    montantEnChiffreX: null,
    montantEnChiffreY: null,
    ordreX: null,
    ordreY: null,
    lieuX: null,
    lieuY: null,
    dateX: null,
    dateY: null,
    margeBas: null,
    taillePolice: null,
  };
}
